// extracted by mini-css-extract-plugin
module.exports = {"newsDetails":"NewsDetails_newsDetails__3Extn","alert":"NewsDetails_alert__GGT9p"};